import { default as HeaderRowPanel } from './HeaderRowPanel';

const EXPORT = { HeaderRowPanel };

export default EXPORT;
